import { Chip } from '@mui/material';
import { cn } from 'cn';
import { type MouseEventHandler, useCallback } from 'react';

type P<TOption extends { readonly label: string }> = {
  readonly data: TOption;
  readonly isRemovable: boolean;
  readonly onClick?: (option: TOption) => void;
  readonly onDelete?: MouseEventHandler<HTMLDivElement>;
  readonly useFullWidth?: boolean;
};

export function SelectMultiValueChip<
  TOption extends { readonly label: string },
>({ data, isRemovable, onClick, onDelete, useFullWidth = false }: P<TOption>) {
  const handleClick = useCallback(() => {
    onClick?.(data);
  }, [data, onClick]);

  return (
    <Chip
      className={cn(
        useFullWidth
          ? '-ml-1.5 w-full [&>.MuiChip-label]:w-full'
          : 'mr-1 first:-ml-1.5',
      )}
      label={data.label}
      onClick={onClick ? handleClick : undefined}
      onDelete={isRemovable ? onDelete : undefined}
    />
  );
}
